import { render, staticRenderFns } from "./DraftBox.vue?vue&type=template&id=41bdccdc&scoped=true&"
import script from "./DraftBox.vue?vue&type=script&lang=js&"
export * from "./DraftBox.vue?vue&type=script&lang=js&"
import style0 from "./DraftBox.vue?vue&type=style&index=0&id=41bdccdc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bdccdc",
  null
  
)

export default component.exports